const initialstate = {
  data:[],
  dataview:[],
  
};

const OrgAddFeedbackReducer =  (state = initialstate, action:any)=>{
  switch (action.type){
      case 'fetch_data_success':
          return {... state, data:action.payload};
          case 'fetch_add_data_success':
          return {... state, dataview:action.payload};
                     default :
          return state;
  }
};
export default OrgAddFeedbackReducer;